<!--
 * @Author: 牛字杰 niuzijie@.jtexpress
 * @Date: 2022-07-13 14:16:30
 * @LastEditors: niuziji 18752021112@163.com
 * @LastEditTime: 2022-12-15 16:14:18
 * @FilePath: \jms-jtsd\src\pages\welfare\welfarePc.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="page">
    <img src="https://pro-jms-front.oss-cn-shanghai.aliyuncs.com/baw/applets/auto/picWebImage.jpg" alt="" style="width: 100%;position: absolute;top: 0;left:0;opacity: 0;z-index: -999;">
    <div class="banner" :style="{backgroundImage: 'url(' + bannerImg + ')'}"></div>
    <div class="swiper">
      <template v-if="swiperImage && swiperImage.length > 0">
        <swiper :options="swiperOption" class="my-swiper">
          <swiper-slide v-for="(item, index) in swiperImage" :key="index">
            <img  class="images"  :src="item.imageUrl"/>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </template>
    </div>
    <div class="container">
      <div class="header-title">
        <img src="@/assets/img/title.png" alt="">
        <img src="@/assets/img/icon01.png" alt="">
      </div>
      <div class="input-div">
        <span class="input-title">留下信息，极兔带你领福利</span>
        <a-form-model ref="ruleForm" :rules="rules" :model="formData" class="input-modol">
          <div class="person-info">
            <a-form-model-item class="width50" prop="name">
              <a-input v-model.trim="formData.name" :maxLength="50" placeholder="请输入姓名">
                <div class="img-div" slot="prefix">
                  <img :src="nameImg" class="input_icon" alt="">
                </div>
              </a-input>
            </a-form-model-item>
            <a-form-model-item class="width50" prop="mobile">
              <a-input v-model.trim="formData.mobile" :maxLength="11" placeholder="请输入手机号">
                <div class="img-div" slot="prefix">
                  <img :src="phoneImg" class="input_icon" alt="">
                </div>
              </a-input>
            </a-form-model-item>
          </div>
          <div @click="checkAddress" class="position-ssq">
            <a-form-model-item prop="positionSSQ" class="input-info">
              <a-input v-model="formData.positionSSQ" placeholder="请选择省市区" readOnly :maxLength="200" prefix-icon="nameImg">
                <div class="img-div" slot="prefix">
                  <img :src="dizhiImg" class="input_icon dizhi" alt="">
                </div>
              </a-input>
            </a-form-model-item>
          </div>
          <a-form-model-item prop="address">
            <a-input v-model.trim="formData.address" :maxLength="100" placeholder="请输入详细地址" />
          </a-form-model-item>
          <a-form-model-item class="code" prop="captcha">
            <a-input v-model.trim="formData.captcha" :maxLength="4" placeholder="请输入图片验证码">
              <div class="img-div" slot="prefix">
                <img :src="tupianImg" class="cap-code" alt="">
              </div>
              <div class="img-div" slot="suffix">
                <img class="img-code" @click="getCaptcha" :src="imgCodeUrl" alt="图片验证码">
              </div>
            </a-input>
          </a-form-model-item>
        </a-form-model>
        <div class="btn" @click="subumit">点击报名</div>
      </div>
      <div class="detail-title">
        <img src="@/assets/img/activity-title.png" alt="">
        <img src="@/assets/img/icon01.png" alt="">
      </div>
      <div class="detail-content">
        <img :src="activityDetail" alt="">
      </div>
      <div class="qr-code">
        <img src="@/assets/img/code.png" alt="">
      </div>
    </div>

    <van-popup v-model="showAddressSelect" position="bottom" :style="{height: '40%'}">
      <div style="position: relative;">
        <van-tabs v-model="tabActive" @click="handelTabChange" swipeable>
          <van-tab title="省">
            <div class="area-container">
              <div v-if="provinceList.length > 0">
                <div class="item-container"
                     :class="{'active': index === provinceIndex}"
                     v-for="(item, index) in provinceList" :key="index"
                     @click="handleSelected(item, index, 1)">
                  {{ item.nativeName }}
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab title="市">
            <div class="area-container">
              <div v-if="cityList.length > 0 && tabActive === 1">
                <div class="item-container"
                     :class="{'active': index === cityIndex}"
                     v-for="(item, index) in cityList" :key="index"
                     @click="handleSelected(item, index, 2)">
                  {{ item.nativeName }}
                </div>
              </div>
              <div v-else class="empty">暂无数据</div>
            </div>
          </van-tab>
          <van-tab title="区">
            <div class="area-container">
              <div v-if="countyList.length > 0 && tabActive === 2">
                <div class="item-container"
                     :class="{'active': index === countyIndex}"
                     v-for="(item, index) in countyList" :key="index"
                     @click="handleSelected(item, index, 3)">
                  {{ item.nativeName }}
                </div>
              </div>
              <div v-else class="empty">暂无数据</div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </van-popup>
  </div>
</template>

<script>
// 引入插件
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import wx from 'weixin-js-sdk'
import 'swiper/dist/css/swiper.css'
import { RULES } from '@/utils/rules'
import { receiveBenefit, getAppletParams } from '@/api'
import { SIGN_CODE_ACTIVITY } from '@constants'
const nameImg = require('@/assets/img/geren@2x.png')
const phoneImg = require('@/assets/img/huafei@2x.png')
const tupianImg = require('@/assets/img/tupian@2x.png')
const dizhiImg = require('@/assets/img/dizhi@2x.png')
const swiperOption = {
  loop: true,
  speed: 1000,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  // 显示分页
  pagination: {
    el: '.swiper-pagination',
    clickable: true, // 允许分页点击跳转
  },
}
export default {
  name: 'Welfare',
  components: {
    swiper,
    swiperSlide,
  },
  metaInfo: {
    title: '电商卖家限时福利！',
    meta: [
      { name: 'description', content: '极兔福利月：免费寄100件，还有手机领' },
      {
        property: 'og:title',
        content: '电商卖家限时福利！',
        vmid: 'og:title',
      },
      {
        property: 'og:description',
        content: '极兔福利月：免费寄100件，还有手机领',
        vmid: 'og:description',
      },
      {
        property: 'og:image',
        content: 'https://pro-jms-front.oss-cn-shanghai.aliyuncs.com/baw/applets/auto/picWebImage.jpg',
        vmid: 'og:image',
      },
    ],
  },
  data() {
    return {
      animateDuration: 0.3,
      nameImg,
      phoneImg,
      tupianImg,
      dizhiImg,
      swiperOption,
      formData: {
        name: '',
        mobile: '',
        positionSSQ: '',
        address: '',
        provinceName: '', // 省
        provinceId: '',
        cityName: '', // 市
        cityId: '',
        areaName: '',
        areaId: '',
        captcha: '', // 图片验证码
        source: '', // 来源
        ctoken: '',
      },
      value: '',
      rules: {
        name: [RULES.required],
        mobile: [RULES.required, RULES.phoneNumber],
        address: [RULES.required],
        captcha: [RULES.required],
        positionSSQ: [],
      },
      imgCodeUrl: '', // 图片验证码
      showAddressSelect: false,
      areaList: {
        province_list: {},
        city_list: {},
        county_list: {},
      }, // 地址列表

      provinceList: [],
      cityList: [],
      countyList: [],
      tabActive: 0,
      provinceIndex: '', // 选中的省份索引
      cityIndex: '', // 选中的城市索引
      countyIndex: '', // 选中的地区索引

      areaObj: {
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        countyId: '',
        countyName: '',
      },

      bannerImg: '', // banner图
      swiperImage: [], // 轮播图
      activityDetail: '', // 活动规则
      areaOptions: [],
    }
  },
  async created() {
    this.getCaptcha()
    this.getSource()
    this.getImgList(96)
    this.getImgList(95)
    this.getImgList(94)

    await this.getAddressList(2, 1)
    this.immediateCouponCollection()
  },
  methods: {
    get_env () { // 根据环境设置地址
      let env = ''
      switch (process.env.VUE_APP_ENV) {
        case 'prod':
          env = 'https://coupon.jtexpress.com.cn'
          break
        case 'uat':
          env = 'https://uat-coupon.jtexpress.com.cn'
          break
        case 'development':
          env = 'http://test-coupon.jms.com'
          break
        default:
          env = 'https://coupon.jtexpress.com.cn'
          break
      }
      return env
    },
    async immediateCouponCollection () {
      const env = this.get_env() // 当前环境域名
      const { source } = this.$route.query // 来源路径
      const WX_IMG_URL = 'https://pro-jms-front.oss-cn-shanghai.aliyuncs.com/baw/applets/auto/picWebImage.jpg' // 微信分享图片
      const WX_Title = '电商卖家限时福利！' // 微信分享标题
      const WX_DES = '极兔福利月：免费寄100件，还有手机领' // 微信分享描述
      const WX_LINK = `${env}/welfare?source=${source}`
      const { code, data } = await getAppletParams.getAppletParams(WX_LINK)
      if (code === 1) {
        wx.config({
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
          openTagList: ['wx-open-launch-weapp'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
        })
        // 通过ready接口处理成功验证
        wx.ready(function () {
          wx.updateAppMessageShareData({
            link: WX_LINK,
            title: WX_Title, // 分享标题
            desc: WX_DES, // 分享描述
            imgUrl: WX_IMG_URL, // 分享图标
          })
        })

        wx.ready(function () { // 需在用户可能点击分享按钮前就先调用
          wx.updateTimelineShareData({
            link: WX_LINK,
            title: WX_Title, // 分享标题
            desc: WX_DES, // 分享描述
            imgUrl: WX_IMG_URL, // 分享图标
          })
        })

        // 通过error接口处理失败验证
        wx.error(function (res) {
          console.log(res, '通过error接口处理失败验证')
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
        })
      }
    },
    async getImgList(type) {
      const params = {
        type,
      }
      const { code, data } = await receiveBenefit.getImgList(params)
      if (code === 1) {
        switch (type) {
          case 96:
            this.bannerImg = data && data[0].imageUrl
            break
          case 95:
            this.swiperImage = data
            break
          case 94:
            this.activityDetail = data && data[0].imageUrl
            break
          default:
            break
        }
      }
    },
    getSource() {
      const { source } = this.$route.query
      this.formData.source = source
    },
    checkAddress() {
      this.showAddressSelect = true
    },
    async getCaptcha() { //  获取图片验证码
      const { code, data } = await receiveBenefit.getCaptcha()
      if (code === 1) {
        this.imgCodeUrl = data.img
        this.formData.ctoken = data.ctoken
      }
    },
    changearea(picker, values, column) {
      // values当前选中值
      // column当前滑动列索引012
      if (column === 0) {
        this.getAddressList(column + 3, Number(values[0].code))// 获取当前省下的城市
      } else if (column === 1) {
        this.getAddressList(column + 3, Number(values[1].code))// 获取当前省下的城市
      }
    },
    /**
     * 普通选择器逻辑
     * @param type
     * @param parentId
     * @returns {Promise<void>}
     */
    async getAddressList(type, parentId) {
      const params = {
        type,
        parentId,
        addressType: 1,
      }
      const { code, data } = await receiveBenefit.getAddressList(params)
      if (code === 1) {
        if (type === 2) {
          this.provinceList = data
        } else if (type === 3) {
          this.cityList = data
        } else if (type === 4) {
          this.countyList = data
        }
      }
    },
    /**
     * 过滤地区数据
     * @param data
     * @returns {{children: [], id: *, text: *, parentId: *}[]|*[]}
     */
    areaFilter(data) {
      if (data instanceof Array) {
        return data.map(item => ({ id: item.id, text: item.nativeName, parentId: item.parentId, children: null }))
      } else {
        return []
      }
    },
    /**
     *
     * @param item
     * @param index
     * @param type
     */
    async handleSelected(item, index, type) {
      if (type === 1) {
        this.provinceIndex = index
        this.areaObj.provinceId = item.id
        this.areaObj.provinceName = item.nativeName
        await this.getAddressList(3, item.id)
        this.provinceIndex = ''
        this.cityIndex = ''
        this.countyIndex = ''
        this.tabActive = 1
      }
      if (type === 2) {
        this.cityIndex = index
        this.areaObj.cityId = item.id
        this.areaObj.cityName = item.nativeName
        await this.getAddressList(4, item.id)
        this.tabActive = 2
      } else if (type === 3) {
        this.countyIndex = index

        this.formData.provinceId = this.areaObj.provinceId
        this.formData.provinceName = this.areaObj.provinceName
        this.formData.cityId = this.areaObj.cityId
        this.formData.cityName = this.areaObj.cityName
        this.formData.areaId = item.id
        this.formData.areaName = item.nativeName
        this.showAddressSelect = false
        this.formData.positionSSQ = `${this.formData.provinceName} / ${this.formData.cityName} / ${this.formData.areaName}`
      }
    },
    // tab
    handelTabChange(val) {
      // if (!this.formData.provinceId && val === 1) {
      //   return
      // }
      // if (!this.formData.cityId && val === 2) {
      //   return
      // }

      // this.tabActive = val
    },
    // 获取省市区数据
    async getAddressList111(type, parentId) {
      const params = {
        type,
        parentId,
        addressType: 1,
      }
      const { code, data } = await receiveBenefit.getAddressList(params)
      if (code === 1) {
        if (type === 2) {
          const province_temp = {}
          const province = data
          province.forEach(item => {
            province_temp[item.id] = item.nativeName
          })
          this.areaList['province_list'] = province_temp
        } else if (type === 3) {
          const city_temp = {}
          const city = data
          // 不要在循环中直接操作渲染的数据，存到变量上，之后一次给值
          city.forEach(item => {
            city_temp[item.id] = item.nativeName
          })
          this.areaList['city_list'] = city_temp
        } else if (type === 4) {
          const county_temp = {}
          const county = data
          county.forEach(item => {
            county_temp[item.id] = item.nativeName
          })
          this.areaList['county_list'] = county_temp
        }
      }
    },
    async confirm(e) {
      if (e[2] && e[2].code) {
        this.formData.provinceName = e[0].name // 省
        this.formData.provinceId = e[0].code // 省
        this.formData.cityName = e[1].name // 省
        this.formData.cityId = e[1].code // 省
        this.formData.areaName = e[2].name // 省
        this.formData.areaId = e[2].code // 省
        this.formData.positionSSQ = `${e[0].name} / ${e[1].name} / ${e[2].name}`
        this.showAddressSelect = false
      }
    },
    // 提交
    async subumit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const times = new Date().valueOf()
          const sign = this.$md5(this.$md5(this.formData.source + '' + times + SIGN_CODE_ACTIVITY))
          const params = {
            times,
            sign,
            ...this.formData,
          }
          const { code, msg } = await receiveBenefit.addReceiveBenefit(params)
          if (code === 1) {
            this.getCaptcha()
            this.$toast.success({
              message: '报名成功',
              duration: 2000,
            })
            this.resetForm()
          } else {
            this.getCaptcha()
            this.$toast.fail({
              message: msg,
              duration: 2000,
            })
          }
        }
      })
    },
    resetForm() {
      this.$refs.ruleForm.resetFields()
      this.formData.provinceName = ''
      this.formData.provinceId = ''
      this.formData.cityName = ''
      this.formData.cityId = ''
      this.formData.areaName = ''
      this.formData.areaId = ''
    },
    oncancel() {
      this.showAddressSelect = false
    },
  },
}
</script>

<style lang="scss" scoped>

.banner {
  width: 100%;
  height: 580rpx;
  // background-image: url('../../assets/img/banner-m.png');
  background-size: 100% 100%;
}
.swiper {
  width: 100%;
  height: 343rpx;
  background: #ffffff;
  .my-swiper {
    padding: 22rpx 0 53rpx 0;
    margin: 0 36rpx;
    box-sizing: border-box;
    .images {
      width: 100%;
      height: 268rpx;
      object-fit: cover;
    }
    ::v-deep {
      .swiper-pagination-bullet {
        width: 11rpx;
        height: 11rpx;
        border: 2rpx solid #EE0201;
        border-radius: 50%;
        background: #ffffff;
        opacity: 1;
      }
      .swiper-pagination-bullet-active {
        width: 11rpx;
        height: 11rpx;
        background: #EF0E0D;
        border-radius: 50%;
      }
    }
  }
}
.container {
  width: 100%;
  // height: 3595rpx;
  background-image: url('../../assets/img/bg-m.png');
  background-size: 100% 100%;
  padding: 42rpx 36rpx;
  box-sizing: border-box;
  .header-title {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    img:nth-child(1) {
      width: 425rpx;
      height: 99rpx;
    }
    img:nth-child(2) {
      width: 23rpx;
      height: 30rpx;
      margin: 11rpx 0 9px 0;
    }
  }
  .input-div {
    width: 100%;
    background: #ffffff;
    text-align: center;
    padding: 34rpx 55rpx;
    box-sizing: border-box;
    .input-title {
      display: inline-block;
      font-size: 32rpx;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #F20101;
      line-height: 32rpx;
      margin-bottom: 17rpx;
    }
    .input-modol {
      .person-info {
        display: flex;
        justify-content: space-between;
      }
      .position-ssq {
        min-height: 130rpx;
      }

      .img-div {
        display: flex;
        align-items: center;
        margin-left: 10rpx;
        position: relative;
        img {
          width: 27rpx;
          height: 35rpx;
          margin-left: -6px;
        }
        .cap-img {
          width: 32rpx;
          height: 20rpx;
        }
        .dizhi {
          width: 27rpx;
          height: 35rpx;
          margin-left: -6px;
        }
        .cap-code {
          width: 28rpx;
          height: 24rpx;
        }

        .img-code {
          width: 180rpx;
          height: 80rpx;
          position: absolute;
          right: -24rpx;
          top: -40rpx;
        }
      }
    }
    ::v-deep {
      .ant-input {
        font-size: 22rpx;
        height: 82rpx;
        padding-left: 60rpx;
        background: #F0F0F0;
        border-color: #d9d9d9;
        &::placeholder {
          font-size: 22rpx;
        }
      }
      .ant-form-item {
        margin-bottom: 0;
      }
      .el-input__prefix {
        display: flex;
        align-items: center;
      }
      .ant-form-item {
        min-height: 130rpx;
      }
      .ant-form-explain {
        text-align: left;
      }
      .ant-input-affix-wrapper {
        border-color: #EE0201;
      }
      .ant-input-affix-wrapper:hover {
        border-color: #EE0201;
      }
      .ant-input:hover {
        border-color: #EE0201;
      }
      .ant-input:focus {
        border-color: #EE0201;
        box-shadow: 0 0 0 2px rgb(238 2 1 / 20%)
      }
    }
    .name-phone {
      display: flex;
      justify-content: space-between;
    }
    .width50 {
      width: 48%;
    }
    .code {
      .img-code {
        width: 100rpx;
        height: 80rpx;
      }
    }
    .btn {
      width: 227rpx;
      height: 62rpx;
      background: #E60000;
      border-radius: 5rpx;
      font-size: 32rpx;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 64rpx;
      margin: 0 auto;
    }
  }
  .detail-title {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    img:nth-child(1) {
      margin-top: 42rpx;
      width: 168rpx;
      height: 44rpx;
    }
    img:nth-child(2) {
      width: 23rpx;
      height: 30rpx;
      margin: 17rpx 0 26rpx 0;
    }
  }
  .detail-content {
    img {
      width: 678rpx;
      height: 2492rpx;
    }
  }
  .qr-code {
    text-align: center;
    margin-top: 67rpx;
    img {
      width: 276rpx;
      height: 142rpx;
    }
  }
}

.area-container{

  .item-container {
    padding: 25rpx 20rpx;
    font-size: 26rpx;
    font-weight: 400;
    color: #666666;
    border-top: 1px solid #eeeeee;
    text-align: center;

    &.active {
      color: #e60000;
    }
  }

  .empty {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #cccccc;
  }
}

::v-deep {
  .van-tab__text {
    font-size: 28rpx;
  }

  .van-tabs__wrap {
    position: sticky;
    top: 0;
  }
}
</style>
